import React, { useContext, useEffect, useState } from "react";
import { GLOBAL_LANGUAGE } from "../../language/language";
import { UtilContext } from "../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import { AuthContext } from "../../context/AuthContext"; // Asegúrate de importar el contexto correcto
import { useNavigate } from "react-router-dom";

import SuccessRecovery from "../../components/layouts/login/SuccessRecovery";
import RequestPassword from "../../components/layouts/login/RequestPassword";
import LoginLayout from "../../components/layouts/login/Login";
import OTP from "../../components/layouts/login/Otp";
import Logo from "../../assets/logos/LogoColurs.png";
import Banner from '../../assets/logos/banner2.png'
import ColorsMain from "../../colors/ColorsMain";
import "../../css/login/login.css";
import forge from 'node-forge';
import axios from "axios";





export const Login = () => {
  const { isAuth, setAuthToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const [Layout, setLayout] = useState(1);
  const secretKey = process.env.REACT_APP_HASH;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [errorUsername, setErrorUsername] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [errorInput, setErrorInput] = useState(false)
  const [errorOTP, seterrorOTP] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { language } = useContext(UtilContext);

  useEffect(() => {
    if (isAuth) {
      navigate("/splash"); // Redirige al dashboard si el usuario ya está autenticado
    }
  }, [isAuth, navigate]);
  const fechTokenRedirect = async (token) => {


    await axios
      .post(`/api/verification_token`, {

        token: token
      },
      )
      .then((response) => {
        setAuthToken(response.data.data.access);
        localStorage.setItem("refreshToken", response.data.data.refresh);
        localStorage.setItem("expiresAtC", new Date().toString());

      })
      .catch((error) => {

      });
    setLoading(false)
  }

  useEffect(() => {
    setErrorInput(false)
  }, [email]);

  const LoginRequest = async () => {
    setLoading(true)
    setErrorPassword(false);
    setErrorUsername(false);
    setError("");
    let data = {};

    if (otp.join("") === "") {
      data = {
        username: email.toLowerCase(),
        password: password,
      };
    } else {
      data = {
        username: email.toLowerCase(),
        password: password,
        otp: otp.join(""),
      };
    }


    await axios
      .post(`/api/login`, { data })
      .then((response) => {


        if (response.data.status === 200) {
          setAuthToken(response.data.data.access);
          localStorage.setItem("refreshToken", response.data.data.refresh);
          localStorage.setItem("expiresAtC", new Date().toString());
        }
      })
      .catch((error) => {
        if (error.response.data.status === 401) {
          if (error.response.data.data.code_transaction === "AuthenticationFailed") {
            setError(error.response.data.data.message);
            setErrorPassword(true);
            setErrorUsername(true);
          }
        } else if (error.response.data.status === 400) {
          if (error.response.data.data.code_transaction === "ValidationError") {
            // Validar qué campo está vacío basado en los datos enviados
            if (!email) {
              setErrorUsername(true);
              setError("Este campo no puede estar en blanco.");
            }
            if (!password) {
              setErrorPassword(true);
              setError("Este campo no puede estar en blanco.");
            }
          } else if (error.response.data.data.code_transaction === "OTPRequiredException") {
            setLayout(2);
          } else if (error.response.data.data.code_transaction === "INVALID_OTP") {
            seterrorOTP("OTP invalido");
          }
        }
      });
    setLoading(false)
  };
  useEffect(() => {

    seterrorOTP("")
    if (otp.join("").length === 6) {
      LoginRequest();
    }
  }, [otp]);

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // Solo permite un carácter
    setOtp(newOtp);

    // Mueve el foco al siguiente input si hay un valor
    if (value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }

    // Si todos los dígitos están llenos, puedes hacer algo (como enviar el OTP)
    if (newOtp.every((digit) => digit !== "")) {
      setOtp(newOtp);
      // Aquí puedes agregar la lógica para manejar el OTP completo
    }
  };
  const requestRecoveryPassword = async () => {
    setEmail("")
    setError('')
    setErrorInput(false)
    setLoading(true)


    await axios
      .post(`/api/password_recovery`, {

        email: email.toLowerCase()
      },
      )
      .then((response) => {
        console.log('FASE 1');
        if (response.data.status === 200) {
          setLayout(4)
        }
        if (response.data.status === 404) {
          setError('Este correo no existe en el sistema')
          setErrorInput(true)
        }
      })
      .catch((error) => {
        setErrorInput(true)
        console.log(error, 'esto es lo que va llegar aca');
      });
    if (email === '') {
      setError('Debe ingresar un correo')
      setErrorInput(true)
    }

    setLoading(false)
  }
  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace") {
      if (otp[index] === "") {
        // Si el campo actual está vacío, retrocede al campo anterior
        if (index > 0) {
          const newOtp = [...otp];
          newOtp[index - 1] = ""; // Borra el dígito del campo anterior
          setOtp(newOtp);
          document.getElementById(`otp-input-${index - 1}`).focus(); // Mueve el foco al campo anterior
        }
      } else {
        // Si hay un valor en el campo actual, simplemente lo borra
        const newOtp = [...otp];
        newOtp[index] = ""; // Borra el dígito del campo actual
        setOtp(newOtp);
      }
    }
  };
  function decryptWithAesSimple(transformedToken,) {
    try {
      // Asegurarse de que la clave tenga exactamente 32 bytes (AES-256)
      const key = forge.util.createBuffer(secretKey.slice(0, 32), 'utf8').bytes();
      console.log("Clave (en bytes):", key);

      // Reemplazar los caracteres URL-safe de Base64
      let encryptedToken = transformedToken.replace(/-/g, '+').replace(/_/g, '/');
      console.log("Token después de reemplazar URL-safe:", encryptedToken);

      // Asegurar que la longitud del token sea un múltiplo de 4 para Base64
      while (encryptedToken.length % 4 !== 0) {
        encryptedToken += '='; // Ajuste de longitud para Base64 válido
      }
      console.log("Token con relleno añadido:", encryptedToken);

      // Decodificar el token cifrado desde Base64
      const encryptedBytes = forge.util.decode64(encryptedToken);
      console.log("Bytes descodificados (en binario):", encryptedBytes);

      // Crear un objeto AES en modo ECB
      const decipher = forge.cipher.createDecipher('AES-ECB', key);

      // Iniciar el descifrado
      decipher.start();
      decipher.update(forge.util.createBuffer(encryptedBytes, 'binary'));
      const success = decipher.finish(); // Verificar si la operación fue exitosa

      console.log("Descifrado exitoso:", success);
      if (!success) {
        throw new Error("La operación de descifrado falló.");
      }

      // Obtener el texto descifrado
      const decryptedText = decipher.output.toString('utf8');
      console.log("Texto descifrado:", decryptedText);

      if (!decryptedText) {
        throw new Error('El texto descifrado está vacío.');
      }

      return decryptedText;
    } catch (error) {
      console.error("Error al descifrar el token:", error.message);
      return null;
    }
  }
  const handlePaste = (event) => {
    event.preventDefault(); // Evita el comportamiento predeterminado

    const pastedData = event.clipboardData.getData("Text").trim().slice(0, 6); // Extrae solo los primeros 6 caracteres
    if (!/^[0-9]+$/.test(pastedData)) return; // Verifica que solo sean números

    const newOtp = pastedData.split("");

    setOtp(newOtp);

    // Usa setTimeout para permitir que React actualice el estado antes de modificar los inputs
    setTimeout(() => {
      newOtp.forEach((digit, index) => {
        const inputElement = document.getElementById(`otp-input-${index}`);
        if (inputElement) {
          inputElement.value = digit;
        }
      });

      // Mueve el foco al siguiente campo si hay espacio
      const lastIndex = newOtp.length < 6 ? newOtp.length : 5;
      document.getElementById(`otp-input-${lastIndex}`)?.focus();
    }, 0);
  };


  const returnLogin = () => {
    setEmail("")
    setError(false)
    navigate('/splash')
  }

  const requestPassword = () => {
    setLayout(3)
    setError(false)
    return
  }
  const ReturnLogin = () => {

    setLayout(1)
    navigate("/login")
  }

  useEffect(() => {
    setErrorPassword(false)
    setError('')
  }, [password]);

  useEffect(() => {
    setErrorUsername(false)
    setError('')
  }, [email]);

  useEffect(() => {
    // Obtén los parámetros de la URL
    const searchParams = new URLSearchParams(window.location.search);

    const pop = searchParams.get("pop");
    const token = decryptWithAesSimple(pop)
    fechTokenRedirect(token);
  }, []);

  return (
    <div className="flex w-full h-screen">
      {/* Banner - Solo visible en desktop */}
      <div
        className="hidden lg:flex w-3/5 h-screen relative"
        style={{
          backgroundImage: `url(${Banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <p
          className="
            text-white 
            w-[77%] 
            text-[1.5rem]
            md:text-[2rem]
            md:leading-[3rem]
            lg:text-[2.5rem]  
            lg:leading-[4rem]
            xl:leading-[4.5rem]
            xl:text-[3.5rem]
            2xl:text-[4.5rem]
            2xl:leading-[5rem]
          "
          style={{
            fontFamily: "brico",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          {GLOBAL_LANGUAGE[language].banner_login.p1}<br />
          <span className="text-[#c5c5d3]">
            {GLOBAL_LANGUAGE[language].banner_login.p2}<br />
            {GLOBAL_LANGUAGE[language].banner_login.p3}
          </span>
        </p>
      </div>

      {/* Contenedor del formulario */}
      <div
        className="flex w-full lg:w-2/5 items-center justify-center flex-col"
        style={{ background: ColorsMain.bgMain }}
      >
        <div style={{ width: "75%", marginBottom: 40 }}>
          <img src={Logo} alt="logo colurs" style={{ width: 32, height: 32 }} />
        </div>

        {Layout === 1 && (
          <LoginLayout
            reguestPassword={requestPassword}
            loading={loading}
            errorUsername={errorUsername}
            email={email}
            setEmail={setEmail}
            errorPassword={errorPassword}
            password={password}
            setPassword={setPassword}
            error={error}
            LoginRequest={LoginRequest}
            setLayout={setLayout}
          />
        )}
        {Layout === 2 && (
          <OTP
            error={errorOTP}
            back={setLayout}
            otp={otp}
            handleChange={handleChange}
            handleKeyDown={handleKeyDown}
            handlePaste={handlePaste}
          />
        )}
        {Layout === 3 && (
          <RequestPassword
            email={email}
            setEmail={setEmail}
            LoginRequest={requestRecoveryPassword}
            errorMesagge={error}
            loading={loading}
            onClickBack={returnLogin}
            errorInput={errorInput}
          />
        )}
        {Layout === 4 && (
          <SuccessRecovery
            ReturnLogin={ReturnLogin}
            loading={loading}
          />
        )}
      </div>
    </div>
  );
};



export default Login;
